/**
 * @description This hook provides a functon that, when called with the update knowledge form data,
 *  edits the knowledge entry and reloads the knowledge list.
 */

import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import { ToastContext } from '@seccon/core/contexts/toast';

const useEditKnowledge = () => {
  const toastApi = React.useContext(ToastContext);
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (data) => (
      fetch('/knowledgeCenter/updateDetails', { method: 'PUT', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } })
        .then(decodeJson)
    ),
    // On success, notify the user, clear the knowledge data, and call the onSuccess callback
    onSuccess: () => {
      toastApi.success('Knowledge center entry was updated successfully');
      queryClient.invalidateQueries({ queryKey: ['fetchKnowledge'] });
    },
    // On error, notfify the user
    onError: ({ body }) => {
      toastApi.error(body ? `Error: ${ body }` : 'Unable to update knowledge center entry. Please try again.');
    }
  })

  return mutateAsync;
};

export default useEditKnowledge;
